import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * Carte d'article du fil public.
 *
 * Volontairement sans le corps de l'article : celui-ci se lit sur `url`, la
 * page HTML statique générée par le backend — seule version que les moteurs de
 * recherche et les moteurs de réponse IA savent lire, la SPA leur étant opaque.
 */
export interface BlogArticleCarte {
  id: number;
  slug: string;
  titre: string;
  chapo?: string | null;
  meta_description?: string | null;
  categorie?: string | null;
  cluster?: string | null;
  est_pilier: boolean;
  cover_url?: string | null;
  cover_alt?: string | null;
  temps_lecture_min?: number | null;
  publie_le?: string | null;
  modifie_le?: string | null;
  url?: string | null;
}

/** Fil public du blog. Aucune authentification : ces données sont publiques. */
@Injectable({ providedIn: 'root' })
export class BlogPublicService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}${environment.apiEndpoint}/blog`;

  lister(cluster?: string): Observable<BlogArticleCarte[]> {
    let params = new HttpParams();
    if (cluster) {
      params = params.set('cluster', cluster);
    }
    return this.http.get<BlogArticleCarte[]>(`${this.apiUrl}/public/articles`, { params });
  }
}
